import { TextAlignCenterIcon, TextAlignLeftIcon, TextAlignRightIcon } from "@/icons/widget-menu";

export const TEXT_ALIGN_ICONS = {
    left: TextAlignLeftIcon,
    center: TextAlignCenterIcon,
    right: TextAlignRightIcon,
};
